<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div style></div>
        <h5 class="vue-title">
          <strong>{{ $t("BRINGFIRST") }}</strong>
        </h5>

        <b-form class="formTextSize">
          <b-row>
            <b-col md="5">
              <b-form-group
                id="addressField"
                :label="$t('PARENTSELECTION')"
                label-for="input-1"
              >
                <b-form-input
                  class="inputField"
                  v-model.trim="$v.category.categoryName.$model"
                  type="text"
                  autocomplete="name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" class="textCenterMedia">
               <b-button
                  variant="primary"
                  type="button"
                  @click="createPartnerSubmit"
                  class="px-4 mr-1  formTextSizeBlack paddingMediaQry"
                  >{{ $t("ADDTO") }}</b-button
                >
            </b-col>
          </b-row>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import { CREATE_CATEGORY } from "@/store/actions.type";

export default {
  name: "add-partner",
  components: {},

  data: function() {
    return {
      category: {
        categoryName: ""
      }
    };
  },
  validations: {
    category: {
      categoryName: {}
    }
  },
  methods: {
    createPartnerSubmit(evt) {
      this.$v.$touch();
      if (!this.$v.category.$invalid) {
        this.$store.dispatch(CREATE_CATEGORY, this.category).then(() => {
          this.$bvModal.show("confirmationModal");
        });
      }
    },
    redirect() {
      this.$router.push({
        name: "category"
      });
    }
  }
};
</script>
<style>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
@media (min-width: 770px) {
  .paddingMediaQry {
    margin-top: 28px;
  }
  .textCenterMedia{
    float: "right";
  }
}
</style>
